<template>
  <VueCtkDateTimePicker :range="false" v-model="value"
    id="setTime"
    class="getTime"
    :only-time ="true"
    :color="'var(--color-pri)'"
    :no-label="true"
    :locale="'zh-tw'"
    :minute-interval="interval||30"
    :disabled-hours="disabledH?disabledH:[]"
    :input-size="'md'"
    :format="'HH:mm'"
    :formatted="'HH:mm'"
    :label="'請選擇時間'"/>
</template>

<script>
export default {
  props: ['defaultValue', 'width', 'disabledH', 'interval'],
  data () {
    return {
      value: null
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  created () {
    setTimeout(() => {
      if (this.width) {
        const elem = document.getElementById('setTime-wrapper')
        elem.style.width = this.width
      }
    }, 100)
  },
  watch: {
    defaultValue () {
      if (this.value !== this.defaultValue) {
        this.value = this.defaultValue
      }
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style lang="scss">
#setTime-wrapper {
  width: 290px;
  &>.field {
    .field-clear-button {
      right: 40px;
    }
    &>input[type=text] {
      font-size: 16px!important;
      height: 40px;
      letter-spacing: .1em;
    }
    &::after {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background-color: var(--color-pri);
      mask-image: url(./svg/icon/clock.svg);
      position: absolute;
      right: 10px;
    }
  }
  #setTime-input {
    padding-right: 66px;
    height: 40px;
    font-size: 20px!important;
    color: #676767;
  }
}
</style>
